import type { HttpClient } from '~/shared/api'
import { UniversitiesFiltersService } from './UniversitiesFiltersService'
import { UniversitiesMainService } from './UniversitiesMainService'

export class UniversitiesService {
  readonly main: UniversitiesMainService
  readonly filters: UniversitiesFiltersService

  constructor(http: HttpClient) {
    this.main = new UniversitiesMainService(http)
    this.filters = new UniversitiesFiltersService(http)
  }
}
